import { Link } from 'react-router-dom';
import type { V2Founding } from './content';

export function Founding({ content }: { content: V2Founding }) {
  return (
    <section className="v2-section v2-founding">
      <div className="v2-container">
        <article className="v2-founding-card" data-reveal>
          <span className="v2-founding-stamp" aria-hidden="true">
            <svg viewBox="0 0 100 100">
              <defs>
                <path id="v2-stamp-arc" d="M 50,50 m -36,0 a 36,36 0 1,1 72,0 a 36,36 0 1,1 -72,0" />
              </defs>
              <text>
                <textPath href="#v2-stamp-arc">
                  {content.stampTop} ✦ {content.stampBottom} ✦
                </textPath>
              </text>
            </svg>
            <i className="ph ph-plant" aria-hidden="true" />
          </span>

          <span className="v2-eyebrow">{content.eyebrow}</span>
          <h2 className="v2-h2">{content.title}</h2>
          <p className="v2-body">{content.body}</p>

          <ol className="v2-founding-points" data-reveal-group>
            {content.points.map((point, index) => (
              <li key={point}>
                <span className="v2-founding-index">{String(index + 1).padStart(2, '0')}</span>
                {point}
              </li>
            ))}
          </ol>

          <Link to={content.cta.href} className="v2-btn v2-btn-dark">
            {content.cta.label}
            <i className="ph ph-arrow-right" aria-hidden="true" />
          </Link>
        </article>
      </div>
    </section>
  );
}
